import styled from 'styled-components';
import { Title, theme, Icon, Button } from 'components';

export const SectionContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 24px;
`;

export const Divider = styled.div`
  grid-column: 1 / span 2;
  width: 100%;
  border-bottom: 1px solid ${theme.gray4};
  margin: 0px auto;
`;

export const StyledIcon = styled(Icon)`
  svg {
    vertical-align: baseline;
    color: rgba(0, 0, 0, 0.25);
  }
`;

export const StyledButton = styled(Button)`
  & {
    font-weight: 400;
    width: 190px;
    // Override alignment of button content so that the icons line up
    display: flex;
    align-items: center;
    padding-top: 0px;
    padding-bottom: 0px;
  }
`;
